import type { ApolloError } from '@apollo/client'
import { Typography, Stack, Alert, Button, CircularProgress } from '@mui/material'
import type React from 'react'

interface Props {
  loading: boolean
  success: boolean
  error?: ApolloError
  onRetry: () => void
}

const SubmitStep: React.FC<Props> = ({ loading, success, error, onRetry }) => {
  if (loading) {
    return (
      <Stack alignItems="center" spacing={2} sx={{ py: 4 }}>
        <CircularProgress size={32} sx={{ color: '#1B4554' }} />
        <Typography variant="body2" color="text.secondary">
          Submitting...
        </Typography>
      </Stack>
    )
  }

  if (success) {
    return (
      <Alert severity="success" sx={{ fontSize: '14px' }}>
        Successfully marked income as unable to verify.
      </Alert>
    )
  }

  if (error) {
    return (
      <Stack spacing={2}>
        <Alert severity="error" sx={{ fontSize: '14px' }}>
          {error.message || 'Failed to mark income as unable to verify.'}
        </Alert>
        <Button variant="outlined" onClick={onRetry} sx={{ alignSelf: 'flex-start' }}>
          Try again
        </Button>
      </Stack>
    )
  }

  return null
}

export default SubmitStep
